import { Injectable, inject } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

import { Observable } from 'rxjs';

import { LoaderService } from '../services/loader.service';
import {ConfigService} from '../services/config.service';

@Injectable()
export class IdentificationInterceptor implements HttpInterceptor {
  public loaderService = inject(LoaderService);
  private configService = inject(ConfigService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Clone the request to add the new header
    const clonedRequest = req.clone({
      headers: req.headers
        .set('ShopIdentification', this.configService.getTTNumberReversed())
        .set('Customer-Environment-Id', this.configService.getEnvironmentId())
    });
    // Pass the cloned request instead of the original request to the next handle
    return next.handle(clonedRequest);
  }
}
